/* Conneqt.Point — Natives Upsell/Bundle-Widget (Ersatz für Kaching)
   Ajax Cart API, Multi-Add mit einem Klick, dynamischer Bildwechsel, Live-Total. */
(function () {
  'use strict';
  var root = document.querySelector('[data-upsell]');
  var data = window.CQ_UPSELL;
  if (!root || !data) return;

  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' \u20AC'; };

  // Variante anhand Kapazität + Farbe finden
  function findVariant(cap, col) {
    var list = data.variants;
    var hit = list.filter(function (v) { return v.cap === cap && v.col === col; })[0];
    if (hit) return hit;
    // Fallback: gleiche Kapazität, erste verfügbare Farbe
    return list.filter(function (v) { return v.cap === cap; })[0] || list[0];
  }
  function val(sel) { return sel && sel.value; }
  function q(role, idx) {
    return root.querySelector('select[data-role="' + role + '"]' + (idx != null ? '[data-idx="' + idx + '"]' : ''));
  }

  var carousel = document.querySelector('[data-carousel]');
  var priceTop = document.querySelector('[data-price-top]');

  // --- Zustandsberechnung ---
  function currentBlock() {
    var r = root.querySelector('input[name="ubundle"]:checked');
    return r ? r.value : 'single';
  }
  function singleVariant() { return findVariant(val(q('cap', 0)), val(q('col', 0))); }
  function duoVariants() {
    return [findVariant(val(q('cap', 1)), val(q('col', 1))), findVariant(val(q('cap', 2)), val(q('col', 2)))];
  }
  function caseChecked() { var c = root.querySelector('[data-addon-case]'); return c && c.checked; }
  function caseVariant() {
    var sel = q('case-model');
    if (!sel) return null;
    var id = parseInt(sel.value, 10);
    return data.caseVariants.filter(function (v) { return v.id === id; })[0] || null;
  }

  // --- Preise / Total rendern ---
  function render() {
    var block = currentBlock();
    // Einzel-Preis
    var sv = singleVariant();
    if (sv) root.querySelector('[data-price-single]').textContent = money(sv.price);
    // Duo-Preis (2 Stück minus Rabatt)
    var dv = duoVariants();
    if (dv[0] && dv[1]) {
      var duoTotal = dv[0].price + dv[1].price - data.duoDiscount;
      root.querySelector('[data-price-duo]').textContent = money(duoTotal);
    }

    // Aktiven Block markieren + Config zeigen
    root.querySelectorAll('.ubox[data-block]').forEach(function (b) {
      var name = b.getAttribute('data-block');
      var cfg = b.querySelector('.ubox-cfg');
      if (name === 'case') return; // Add-on separat
      if (name === block) { b.classList.add('is-active'); if (cfg) cfg.hidden = false; }
      else { b.classList.remove('is-active'); if (cfg) cfg.hidden = true; }
    });

    // Add-on Dropdown ein-/ausblenden
    var caseCfg = root.querySelector('[data-cfg="case"]');
    if (caseCfg) caseCfg.hidden = !caseChecked();

    // Gesamt + Ersparnis
    var total = 0, saved = 0;
    if (block === 'single' && sv) { total += sv.price; if (sv.cmp && sv.cmp > sv.price) saved += (sv.cmp - sv.price); }
    if (block === 'duo' && dv[0] && dv[1]) {
      total += dv[0].price + dv[1].price - data.duoDiscount;
      saved += data.duoDiscount;
      [dv[0], dv[1]].forEach(function (v) { if (v.cmp && v.cmp > v.price) saved += (v.cmp - v.price); });
    }
    if (caseChecked()) {
      var cv = caseVariant();
      if (cv) { total += cv.price - data.caseDiscount; saved += data.caseDiscount; }
    }
    root.querySelector('[data-total]').textContent = money(total);
    var sEl = root.querySelector('[data-total-save]');
    sEl.textContent = saved > 0 ? 'Du sparst ' + money(saved) : '';

    updateTopPrice(sv);
  }

  // --- Hauptpreis oben live aktualisieren (bei Kapazitäts-/Farbwahl) ---
  function updateTopPrice(sv) {
    if (!priceTop || !sv) return;
    var amt = priceTop.querySelector('.amount');
    if (amt) amt.textContent = money(sv.price);
    var cmp = priceTop.querySelector('.compare');
    if (cmp) {
      if (sv.cmp && sv.cmp > sv.price) { cmp.textContent = money(sv.cmp); cmp.style.display = ''; }
      else { cmp.style.display = 'none'; }
    }
  }

  // --- Bildwechsel bei Variantenwahl: Karussell zum passenden Farbbild springen ---
  function swapImage() {
    if (!carousel) return;
    var block = currentBlock();
    var v = block === 'duo' ? duoVariants()[0] : singleVariant();
    if (!v || !v.imgid) return;
    var slides = carousel.querySelectorAll('.pdp-slide');
    var idx = -1;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-img-id') === String(v.imgid)) { idx = i; break; }
    }
    if (idx < 0) return;
    carousel.scrollTo({ left: idx * carousel.clientWidth, behavior: 'smooth' });
    var wrap = carousel.closest('[data-gallery]') || carousel.parentNode;
    wrap.querySelectorAll('[data-dot]').forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
    wrap.querySelectorAll('[data-thumb-index]').forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.thumbIndex, 10) === idx); });
  }

  // --- Events ---
  root.addEventListener('change', function (e) {
    render();
    if (e.target.matches('select[data-role="col"], select[data-role="cap"], input[name="ubundle"]')) swapImage();
  });

  // Klick auf Box wählt zugehörigen Radio
  root.querySelectorAll('.ubox[data-block="single"], .ubox[data-block="duo"]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (e.target.closest('select')) return;
      var r = b.querySelector('input[type="radio"]');
      if (r && !r.checked) { r.checked = true; render(); swapImage(); }
    });
  });

  // --- In den Warenkorb (Ajax, Multi-Add) ---
  var addBtn = root.querySelector('[data-upsell-add]');
  addBtn.addEventListener('click', function () {
    var block = currentBlock();
    var items = [];
    if (block === 'single') { var sv = singleVariant(); if (sv) items.push({ id: sv.id, quantity: 1 }); }
    if (block === 'duo') { duoVariants().forEach(function (v) { if (v) items.push({ id: v.id, quantity: 1 }); }); }

    var addCase = caseChecked();
    if (addCase) { var cv = caseVariant(); if (cv) items.push({ id: cv.id, quantity: 1 }); }

    if (!items.length) { alert('Bitte eine Variante wählen.'); return; }

    var code = '';
    if (block === 'duo' && addCase) code = root.dataset.discountMax;
    else if (block === 'duo') code = root.dataset.discountDuo;
    else if (addCase) code = root.dataset.discountCase;

    addBtn.disabled = true;
    addBtn.textContent = 'Wird hinzugefügt …';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // Rabatt-Code automatisch anwenden -> Checkout; sonst Warenkorb öffnen
        if (code) { window.location.href = '/checkout?discount=' + encodeURIComponent(code); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.innerHTML = 'In den Warenkorb';
        alert('Es gab ein Problem. Bitte erneut versuchen.');
      });
  });

  // Init
  render();
})();
